import { createApiRef } from '@backstage/frontend-plugin-api';
import {
  PassedRulesStatistics,
  RulesCompliance,
  RulesStatistics,
} from '@internal/backstage-plugin-catalog-devops-common';

export const rulesStatisticsApiRef = createApiRef<RulesStatisticsApi>().with({
  id: 'rules-statistics-api',
  pluginId: 'catalog-devops',
});

export interface RulesStatisticsApi {
  getRulesStatistics(accountId: string): Promise<RulesStatistics[]>;
  getPassedRulesStatistics(accountId: string): Promise<PassedRulesStatistics[]>;
  getCompliance(accountId: string): Promise<Record<string, RulesCompliance>>;
  getComplianceByRuleSet(
    ruleSetName: string,
  ): Promise<Record<string, RulesCompliance>>;
}
